define('app/editor/dialogs/SaveSegmentDialogView',['require','./SaveDialogView','app/app','glu/util','glu/dialog','hbs!./SaveSegmentDialogView.hbs'],function(require) {
	'use strict';

	var
		SaveDialogView = require('./SaveDialogView'),
		App = require('app/app'),
		_ = require('glu/util'),
		dialog = require('glu/dialog');

	var view = SaveDialogView.extend({

		dialogTitle: 'Save As a Segment',

		getClass: function() {
			return 'modal-save-segment';
		},

		template: require('hbs!./SaveSegmentDialogView.hbs'),

		publicFieldId: '#save-dialog-as-public',

		getName: function() {
			return !this.options.saveAs ? this.model.getName() : '';
		},

		getDescription: function() {
			return !this.options.saveAs ? this.model.getDescription() : '';
		},

		save: function() {
			var self = this;

			if (this.isValid()) {
				var segment = this.model;
				segment.setName(this.uigetName());
				segment.setDescription(this.uigetDescription());
				segment.setIsPrivate(true);
				segment.save().then(function(res) {
					segment.set('id', res, {
						silent: true
					});
					self.trigger('saveSegment', segment.get('id'));
					if (self.options.saveAs) {
						self.navigateTo('/domains/' + segment.getDomainId() + '/segments/' + segment.get('id'));
					}
				});
				dialog.close();
			}
		},

		validate: function(val, field) {
			// call base class isValid function
			SaveDialogView.prototype.validate.call(this, val, field);

			if (this.$el.find(this.nameFieldId).parent().hasClass('has-error')) {
				return;
			}

			var desiredName = this.uigetName();
			// check for duplicate name
			// get all segments names
			var segment = _.find(App.segments.models, function(s) {
				if (s.isOwner() && s.getName().trim() === desiredName.trim()) {
					return s;
				}
			});

			if (segment) {
				this.$el.find(this.nameFieldId).parent().addClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text('Duplicate alert name');
			} else {
				this.$el.find(this.nameFieldId).parent().removeClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text();
			}
		}

	});
	return view;
});

